import swal from 'sweetalert2';

function showSwal({type, title, text}) {
	if (type === 'fail') {
		swal.fire({
			title: title,
			text: text,
			buttonsStyling: false,
			confirmButtonClass: 'btn btn-warning',
			icon: 'warning',
			customClass: {
				popup: 'notification-popup',
			},
		});
	}
	if (type === 'success') {
		return swal.fire({
			title: title,
			text: text,
			buttonsStyling: false,
			confirmButtonClass: 'btn btn-success',
			icon: 'success',
			customClass: {
				popup: 'notification-popup',
			},
		});
	}
	if (type === 'info') {
		swal.fire({
			title: title,
			text: text,
			buttonsStyling: false,
			confirmButtonClass: 'btn btn-info',
			icon: 'info',

			customClass: {
				popup: 'notification-popup',
			},
		});
	}
}

function showConfirmSwal({ title, text, yesButton, noButton }, confirmCallBack, dismissCallBack) {
	const swalWithBootstrapButtons = swal.mixin({
		customClass: {
			confirmButton: 'btn btn-danger',
			cancelButton: 'btn btn-secondary',
		},
		buttonsStyling: false,
	});

	swalWithBootstrapButtons
		.fire({
			title: title,
			text: text,
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: yesButton,
			cancelButtonText: noButton,
			reverseButtons: false,
		})
		.then((result) => {
			if (result.isConfirmed) {
				confirmCallBack();
			} else if (
				/* Read more about handling dismissals below */
				result.dismiss === swal.DismissReason.cancel
			) {
				dismissCallBack();
			}
		});
}

function showConfirmSwalWithCheckbox({ title, text, checkboxText, yesButton, noButton }, confirmCallBack, dismissCallBack) {
	const swalWithBootstrapButtons = swal.mixin({
		customClass: {
			confirmButton: 'btn btn-danger',
			cancelButton: 'btn btn-secondary',
		},
		buttonsStyling: false,
	});

	swalWithBootstrapButtons
		.fire({
			title: title,
			html:
				`<div>
				<p>${text}</p>
				<label>
					<input type="checkbox" id="customCheckbox">
					${checkboxText}
				</label>
				</div>`,
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: yesButton,
			cancelButtonText: noButton,
			reverseButtons: false,
		})
		.then((result) => {
			if (result.isConfirmed) {
				const isChecked = document.getElementById('customCheckbox').checked;
				confirmCallBack(isChecked);
			} else if (result.dismiss === swal.DismissReason.cancel) {
				dismissCallBack();
			}
		});
}

function showSuccessSwal({ title, text, yesButton, noButton }, confirmCallBack, dismissCallBack) {
	const swalWithBootstrapButtons = swal.mixin({
		customClass: {
			confirmButton: 'btn btn-danger',
			cancelButton: 'btn btn-secondary',
		},
		buttonsStyling: false,
	});

	swalWithBootstrapButtons
		.fire({
			title: title,
			text: text,
			icon: 'success',
			showCancelButton: true,
			confirmButtonText: yesButton,
			cancelButtonText: noButton,
			reverseButtons: false,
		})
		.then((result) => {
			if (result.isConfirmed) {
				confirmCallBack();
			} else if (
				/* Read more about handling dismissals below */
				result.dismiss === swal.DismissReason.cancel
			) {
				dismissCallBack();
			}
		});
}

export { showSwal, showConfirmSwal, showSuccessSwal, showConfirmSwalWithCheckbox};
